<template>
  <cTable
    ref="table"
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
  >
  </cTable>
</template>

<script>
import {
  getPlatReturnService,
  getRemarkList,
  addRemark,
  getPlatReturnDetail,
  batchAddRemarks,
} from "@/api/forecastManagement/platReturnService";
// import { getCountry } from "@/api/system/country";
// import { getUser } from "@/api/user/internal";
// import { getChannel } from "@/api/tracker/channel";
// import { getAgent } from "@/api/tracker/agent";
// import { getStatus } from "@/api/tracker/status";
import { getAllClient } from "@/api/user/client";
// import { getUser } from "@/api/user/internal";
import cTable from "@/base/common/index";
import { getSelectType, getKeysType } from "@/api/public";
export default {
  name: "platReturnService",
  components: {
    cTable,
  },
  data() {
    let that = this;
    return {
      statusId: "",
      setData: {},
      methods: {
        list: getPlatReturnService,
        getRemarkList,
        addRemark,
        getAllClient,
        getSelectType,
        getPlatReturnDetail,
        batchAddRemarks,
      },
      config: {
        height: 630,
        rowId: "id",
        hideVisible: ["sku", "sku_number", "warehouse_sku_number"],
      },
      modals: {
        remark: {
          type: "add",
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("batchAddRemarks", row, true, true)
                .then((res) => {
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            rules: {
              remarks: [
                {
                  required: true,
                  message: "remarks be empty",
                  trigger: "bulr",
                },
              ],
            },
            formBind: {
              labelWidth: 100,
            },
            title: this.$t("add") + this.$t("order_desc"),
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
          },
          grid: [{ remarks: 24 }],
          fields: [
            {
              key: "remarks",
              name: () => this.$t("order_desc"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("order_desc");
              },
              bind: {
                type: "textarea",
                rows: 5,
              },
            },
          ],
        },
        remarksList: {
          config: {
            listFn: "getRemarkList",
            // isNoPage: true,
            modalBind: {
              width: 600,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            buttons: {
              bind: {
                style: {
                  display: "flex",
                  "justify-content": "flex-end",
                  "align-items": "center",
                },
              },
            },
          },
          footer: {
            show: false,
          },
          grid: [{ remarks: 24 }],
          buttons: [
            {
              name: () => this.$t("addTo") + this.$t("order_desc"),
              // id: 948,
              bind: {
                type: "primary",
                style: {
                  margin: 0,
                  marginBottom: "20px",
                },
              },
              show: (row) =>
                row.formData.type != 1 && this.$hasPermission(1175),
              disabled: ({ formData }) => {
                return !formData["remarks"];
              },
              methods: {
                click({ row }) {
                  this.$page
                    .handleRequestMethods("addRemark", row)
                    .then((res) => {
                      this.$modal.$refs["form"].clear();
                      this.$modal.getList();
                      this.$page.getList();
                    });
                },
              },
            },
          ],
          fields: [
            {
              key: "remarks",
              name: () => this.$t("order_desc"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("order_desc");
              },
              show: function ({ row }) {
                return this.$modal.type != 1 && this.$hasPermission(1175);
              },
              // id: 948,
              bind: {
                type: "textarea",
                autosize: { minRows: 3, maxRows: 6 },
              },
            },
          ],
          table: {
            config: {
              height: 500,
            },
            fields: [
              {
                name: () => this.$t("operate"),
                key: "operator_name",
              },
              {
                name: () => this.$t("operation") + this.$t("time"),
                key: "create_time",
              },
              {
                name: () => this.$t("order_desc"),
                key: "remarks",
              },
              // {
              //   type: "btns",
              //   width: 150,
              //   name: () => this.$t("operation"),
              //   fixed: "right",
              //   // width({ field }) {
              //   //   return field.list.length * 40 + 40;
              //   // },
              //   list: [
              //     {
              //       name: () => this.$t("delete"),
              //       type: "delete",
              //       fnName: "delete",
              //       // id: 160,
              //       bind: {
              //         type: "error",
              //       },
              //     },
              //   ],
              //   methods: {
              //     delete({ row }) {
              //       this.$Modal.confirm({
              //         title: this.$t("delete"),
              //         width: 300,
              //         content: this.$t("titleModal"),
              //         onOk: () => {
              //           this.handleRequestMethods(
              //             "delRemark",
              //             row.id,
              //             true,
              //             true
              //           ).then((res) => {
              //             this.getModal("remarksList").getList();
              //             this.getList();
              //           });
              //         },
              //       });
              //     },
              //   },
              // },
            ],
          },
          methods: {
            ok() {
              let obj = {
                name: this.$t("bagList"),
                fields: this.table.fields,
                data: this.list,
              };
              this.$page.exportExc(obj);
            },
          },
        },
        remarks: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("addRemark", row, true)
                .then((res) => {
                  console.log(this);
                  // this.getList();
                  close();
                });
            },
          },
          config: {
            rules: {
              remark: [
                {
                  required: true,
                  message: "remarks be empty",
                  trigger: "bulr",
                },
              ],
            },
            formBind: {
              labelWidth: 60,
            },
            title: this.$t("add") + this.$t("order_desc"),
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
          },
          grid: [{ remark: 24 }],
          fields: [
            {
              key: "remark",
              name: () => this.$t("order_desc"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("order_desc");
              },
              bind: {
                type: "textarea",
                rows: 5,
              },
            },
          ],
        },
        detail: {
          config: {
            listFn: "getPlatReturnDetail",
            // isNoPage: true,
            modalBind: {
              width: 800,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            buttons: {
              bind: {
                style: {
                  display: "flex",
                  "justify-content": "flex-end",
                  "align-items": "center",
                },
              },
            },
          },
          footer: {
            show: false,
          },
          table: {
            config: {
              height: 500,
            },
            fields: [
              {
                name: () => "Sku",
                key: "sku",
              },
              {
                name: () => this.$t("Customer forecast quantity"),
                key: "sku_number",
              },
              {
                name: () => this.$t("Receiving Warehouse quantity"),
                key: "warehouse_sku_number",
              },
            ],
          },
          methods: {
            ok() {
              let obj = {
                name: this.$t("bagList"),
                fields: this.table.fields,
                data: this.list,
              };
              this.$page.exportExc(obj);
            },
          },
        },
      },
      header: {
        searchs: [
          {
            key: "client_id",
            component: "Select",
            bind: {
              style: "width:150px",
            },
            placeholder() {
              return this.$t("clientName");
            },
            config: { label: "account", value: "id" },
            options: [],
          },
          {
            key: "warehouse_id",
            component: "Select",
            bind: {
              style: "width:150px",
            },
            placeholder() {
              return this.$t("warehouseName");
            },
            options: [],
          },
          {
            key: "plan",
            component: "Select",
            bind: {
              style: "width:150px",
            },
            placeholder() {
              return this.$t("plan_t");
            },
            options: [],
          },
          {
            key: "is_receive_date",
            component: "Select",
            bind: {
              style: "width:150px",
            },
            placeholder() {
              return (
                this.$t("select") + this.$t("whether") + this.$t("accepted")
              );
            },
            options: [
              {
                label: this.$t("YES"),
                value: "YES",
              },
              {
                label: this.$t("NO"),
                value: "NO",
              },
            ],
          },
          {
            key: "is_process",
            component: "Select",
            bind: {
              style: "width:150px",
            },
            placeholder() {
              return this.$t("select") + this.$t("whether") + this.$t("handle");
            },
            options: [
              {
                label: this.$t("YES"),
                value: "YES",
              },
              {
                label: this.$t("NO"),
                value: "NO",
              },
            ],
          },
          {
            key: "is_prediction",
            component: "Select",
            bind: {
              style: "width:150px",
            },
            placeholder() {
              return (
                this.$t("select") + this.$t("whether") + this.$t("forecast")
              );
            },
            options: [
              {
                label: this.$t("YES"),
                value: "YES",
              },
              {
                label: this.$t("NO"),
                value: "NO",
              },
            ],
          },
          {
            key: "platform",
            component: "Select",
            bind: {
              style: "width:150px",
            },
            placeholder() {
              return this.$t("platform");
            },
            options: [],
          },
          // {
          //   key: "keywordsType",
          //   placeholder() {
          //     return this.$t("select") + this.$t("keywords_type");
          //   },
          //   clearable: false,
          //   component: "Select",
          //   options: [],
          //   methods: {
          //     async list({ field, searchForm }) {
          //       let res = (await getKeysType("EXTRACT_PREDICTION_KEYWORDS"))
          //         .data.payload;
          //       field.options = res;
          //       searchForm[field.key] = res[0].value;
          //       this.$forceUpdate();
          //     },
          //   },
          // },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            bind: {
              style: "width:140px",
              type: "textarea",
              rows: 1,
            },
            component: "Input",
          },
        ],
        btns: {
          list: [
            {
              name: this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary",
              },
            },
            {
              name: this.$t("order_desc"),
              type: "remark",
              fnName: "remark",
              disabled() {
                return !this.selectAll.length;
              },
              id: 1449,
              bind: {
                type: "primary",
              },
            },
          ],
          methods: {
            export() {
              this.exportExc();
            },
            remark() {
              this.getModal("remark").open({
                ids: this.selectAll.map((t) => t.id),
              });
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          fixed: "left",
          width: 60,
        },
        {
          name: () => this.$tz("sku"),
          key: "sku",
          minWidth: 110,
        },
        {
          name: () => this.$tz("客户预报数量"),
          key: "sku_number",
          minWidth: 110,
        },
        {
          name: () => this.$tz("仓库接收数量"),
          key: "warehouse_sku_number",
          minWidth: 110,
        },
        {
          name: () => this.$t("cargo_number"),
          key: "Shipment_number",
          minWidth: 100,
          fixed: "left",
        },
        {
          name: () => this.$t("returnPlatform"),
          key: "platform",
          minWidth: 100,
        },
        {
          name: () => this.$t("shopId"),
          key: "shop_ID",
          minWidth: 100,
        },
        {
          name: () => this.$t("trackingCode"),
          key: "tracking_code",
          minWidth: 100,
        },
        {
          name: () => this.$t("plan_t"),
          key: "plan_name",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("Customer forecast CTNS"),
          key: "number",
          width: 130,
        },
        {
          name: () => this.$t("Receiving Warehouse CTNS"),
          key: "warehouse_number",
          width: 130,
        },
        {
          name: () => this.$t("warehouseName"),
          key: "warehouseTitle",
          width: 120,
        },
        {
          name: () => this.$t("whether") + this.$t("handle"),
          key: "is_process",
          width: 120,
          methods: {
            render({ value }) {
              return this.$t(value);
            },
          },
        },
        {
          name: () => this.$t("whether") + this.$t("forecast"),
          key: "is_prediction",
          width: 120,
          methods: {
            render({ value }) {
              return this.$t(value);
            },
          },
        },
        {
          name: () => this.$t("ReturnTime"),
          key: "return_date",
          width: 130,
        },
        {
          name: () => this.$t("pod_time"),
          key: "receipt_date",
          width: 130,
        },
        {
          name: () => this.$t("ReceiptSign"),
          key: "receipt_sign",
          width: 100,
          component: ({ row }) => {
            return row.receipt_sign ? "Button" : "span";
          },
          bind: {
            type: "primary",
            size: "small",
          },
          methods: {
            click({ row, value }) {
              window.open(row.receipt_sign);
            },
            render({ row, value }) {
              return value ? this.$t("showDetail") : "-";
            },
          },
        },
        {
          name: () => this.$t("ReceiveTime"),
          key: "receive_date",
          width: 130,
        },
        {
          name: () => this.$t("clientName"),
          key: "client_name",
          width: 130,
        },
        {
          name: () => this.$t("addTime"),
          key: "create_time",
          width: 130,
        },
        {
          name: () => this.$t("REMARK"),
          key: "serviceRemarks",
          minWidth: 120,
          component: ({ row }) => {
            return row.serviceRemarks ? "a" : "Button";
          },
          bind: {
            type: "success",
            size: "small",
          },
          // id: 949,
          methods: {
            click({ row, parent }) {
              this.$page.getModal("remarksList").type = 0;
              this.$page
                .getModal("remarksList")
                .open(
                  { platform_return_service_id: row.id, type: 0 },
                  function () {
                    this.setTitle(this.$t("REMARK"));
                    this.pageConfig.data["platform_return_service_id"] = row.id;
                    this.pageConfig.data["type"] = 0;
                    this.getList();
                  }
                );
            },
            render({ row, value }) {
              return value ? value : this.$t("addTo");
            },
          },
        },
        {
          name: () => this.$t("WarehouseNotes"),
          key: "warehouseRemarks",
          minWidth: 120,
          component: "a",
          bind: {
            type: "success",
            size: "small",
          },
          // id: 949,
          methods: {
            click({ row, parent }) {
              this.$page.getModal("remarksList").type = 1;
              this.$page.getModal("remarksList").open(
                {
                  platform_return_service_id: row.id,
                  type: 1,
                },
                function () {
                  this.setTitle(this.$t("WarehouseNotes"));
                  this.pageConfig.data["platform_return_service_id"] = row.id;
                  this.pageConfig.data["type"] = 1;
                  this.getList();
                }
              );
            },
            render({ row, value }) {
              return value;
            },
          },
        },
        {
          type: "btns",
          width: 100,
          name: () => this.$t("operation"),
          fixed: "right",
          list: [
            {
              name: () => this.$t("detail"),
              bind: {
                type: "primary",
                size: "small",
              },
              type: "detail",
              fnName: "detailFun",
            },
          ],
          methods: {
            detailFun({ row }) {
              this.getModal("detail").open(null, function () {
                this.setTitle(this.$t("skuInfo"));
                this.pageConfig.data["id"] = row.id;
                this.getList();
              });
            },
          },
        },
      ],
    };
  },
  async mounted() {
    let setData = await this.$sel.getData([
      "PLATFORM_RETURN_WAREHOUSE",
      "PLATFORM_RETURN_PLAN",
      "PLATFORM",
    ]);
    let clientData = (await getAllClient()).data.payload.rows;
    this.header.searchs.forEach(async (item) => {
      if (item.key === "client_id") item.options = clientData;
      if (item.key === "warehouse_id")
        item.options = setData["PLATFORM_RETURN_WAREHOUSE"];
      if (item.key === "plan") item.options = setData["PLATFORM_RETURN_PLAN"];
      if (item.key === "platform") item.options = setData["PLATFORM"];
    });
  },
};
</script>
